import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ProgressbarConfig, ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

import { MatSidenavModule } from '@angular/material/sidenav';
import { NgxDatatableModule } from '@siemens/ngx-datatable';

// Layout
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { IdBarComponent } from './id-bar/id-bar.component';
import { PageTitleComponent } from './page-title/page-title.component';
import { MemberLoginHelpGlossaryComponent } from './memberLoginHelpGlossery/memberLoginHelpGlossery.component';
import { LargeDataComponent } from './largeDataComponent/large-data.component';

// Modals
import { ConfirmModalComponent } from './modals/confirm/confirm.component';
import { ConfirmAppealModalComponent } from './modals/confirm-appeal/confirm-appeal.component';
import { ConfirmAppealRespComponent } from './modals/confirm-appeal-resp/confirm-appeal-resp.component';
import { ConfirmFileAppealAuthAckComponent } from './modals/confirm-appeal-auth-ack/confirm-appeal-auth-ack.component';
import { PeopleDeleteModalComponent } from '@app/components/modals/people-delete/people-delete.component';
import { FeedbackSurveyModalComponent } from './modals/feedback-survey/feedback-survey.component';
import { ReportAbuseModalComponent } from './modals/report-abuse/report-abuse.component';
import { CommentsModalComponent } from './modals/comments/comments.component';
import { TimeoutModalComponent } from './modals/timeout/timeout.component';
import { IncomeDeductionModalComponent       } from './modals/income-deduction-modal/income-deduction-modal.component';
import { AnalyticsModalComponent } from './modals/analytics/analytics.component';
import { QuestionnaireModalComponent } from './modals/questionnaire/questionnaire.component';
import { InfoMessagesModalComponent } from './modals/info-messages/info-messages.component';
import { PrimaryCaregiversModalComponent } from './modals/primary-caregivers/primary-caregivers.component';
import { AssistingPersonTypesModalComponent } from './modals/assisting-person-types/assisting-person-types.component';
import { LiquidTypesModalComponent } from './modals/liquid-types/liquid-types.component';
import { BurialResourcesModalComponent } from './modals/burial-resources/burial-resources.component';
import { TypesOfProofsComponent } from './modals/types-of-proofs/types-of-proofs.component';
import { ConfirmSsnModalComponent } from './modals/confirm-ssn/confirm-ssn.component'
import { ImmigrationTypesModalComponent } from './modals/immigration-types/immigration-types.component';
// Reusable
import { ButtonBarComponent } from './button-bar/button-bar.component';
import { ContactPhonesComponent } from './contact-phones/contact-phones.component';
import { CountComponent } from './count/count.component';
import { ErrorMessagesComponent } from './error-messages/error-messages.component';
import { FieldComponent } from './field/field.component';
import { FormComponent } from './form/form.component';
import { InputGroupComponent } from './input-group/input-group.component';
import { ContactInfoComponent } from './contact-info/contact-info.component';
import { NameAddressComponent } from './name-address/name-address.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SearchComponent } from './search/search.component';
import { PopoverComponent } from './popover/popover.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SmartAppBannerComponent } from './smart-app-banner/smart-app-banner.component';
import { StepperComponent } from './stepper/stepper.component';
import { TableComponent } from './table/table.component';
import { TabsetComponent } from './tabset/tabset.component';
import { TopLevelComponent } from './top-level/top-level.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { CheckboxDropdownListComponent } from '@app/components/checkbox-dropdown-list/checkbox-dropdown-list.component';
import { CheckboxListComponent } from './checkbox-list/checkbox-list.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { CityStateComponent } from './city-state/city-state.component';
import { BlockTitleComponent } from './block-title/block-title.component';
import { SectionInfoComponent } from './section-info/section-info.component';
import { AlertComponent } from './alert/alert.component';
import { AddressValidationComponent } from './modals/address-validation/address-validation.component';

import { DirectivesModule } from '@app/directives/directives.module';
import { PipesModule } from '@app/pipes/pipes.module';
import { TranslateModule } from "@ngx-translate/core";
import { FileUploadComponent } from './file-upload/file-upload.component';
import { MobileFileUploadComponent } from './mobile-file-upload/mobile-file-upload.component'
import { FileUploadModule } from 'ng2-file-upload';
import { SaveExitModalComponent } from './modals/save-exit/save-exit.component';
import { ReviewSummaryTableComponent } from './review-summary-table/review-summary-table.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { EndCoverageSummaryModalComponent } from './modals/end-coverage-summary-modal/end-coverage-summary-modal.component';
import { CoverageTutorialModalComponent } from './modals/coverage-tutorial-modal/coverage-tutorial-modal.component';
import { JoyrideModule } from 'ngx-joyride';
import { RecordDeleteModalComponent } from './modals/record-delete/record-delete.component';
import { RemoveSvgComponent } from './remove-svg/remove-svg.component';
import { CoOwnerTableComponent } from './co-owner-table/co-owner-table.component';
import { AddSvgComponent } from './add-svg/add-svg.component';
import { KatieBeckettModalComponent } from './modals/katie-beckett/katie-beckett.component';
import { ExitSvgComponent } from './exit-svg/exit-svg.component';
import { BrowserIncompatibleModalComponent } from './modals/browser-incompatible-modal/browser-incompatible-modal.component';
import { HealthPlansComponent } from '@app/components/modals/health-plans/health-plans.component';
import { HealthPlanConfirmModalComponent } from './modals/health-plan-confirm/health-plan-confirm.component';
import { AppealEligibilityModalComponent } from './modals/appeal-eligibility/appeal-eligibility.component';
import { ReportChangeModalComponent } from './modals/report-change-modal/report-change-modal.component';
import { TranslateModalComponent } from './modals/translate-modal/translate-modal.component';
import { DuplicateContinuanceAppealModalComponent } from './modals/duplicate-continuance-appeal/continuance-appeal.component';
import { DuplicateWithdrawlAppealModalComponent } from './modals/duplicate-appeal-withdrawl/duplicate-appeal-withdrawl.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatButtonModule} from '@angular/material/button';
import { MatSortModule } from '@angular/material/sort';
import { NudgeComponent } from './nudge/nudge.component';
import { DuplicateTaxDepOrJointFilerComponent } from './modals/duplicate-taxdep-or-jointfiler/duplicate-taxdep-or-jointfiler.component';
import { mobileFAQComponent } from './modals/mobileFAQ/mobileFAQ.component';
import { ConfirmHohComponent } from './modals/confirm-hoh/confirm-hoh.component';
import { ConfirmOpenAppealModalComponent } from './modals/confirm-open-appeal/confirm-open-appeal.component';
import { HealthPlanCancelConfirmComponent } from './modals/health-plan-cancel-confirm/health-plan-cancel-confirm.component';
import { HealthPlanCancelModalComponent } from './modals/health-plan-cancel-modal/health-plan-cancel-modal.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { HealthPlanCancelErrorComponent } from './modals/health-plan-cancel-error/health-plan-cancel-error.component';
import { SubmissionTypesComponent } from './modals/submission-types/submission-types.component';
import { DocumentTypesComponent } from './modals/document-types/document-types.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { DocUploadFaqsComponent } from './modals/doc-upload-faqs/doc-upload-faqs.component';
import { DocUploadLimitComponent } from './modals/doc-upload-limit/doc-upload-limit.component';
import { AppealFactModalComponent } from './modals/appeal-fact-modal/appeal-fact-modal.component';
import { AppealFactSubmissionComponent } from '@app/gateway/user-profile/my-appeals/appealFactSubmission/appeal-fact-submission.component';
import { AppealPetitionModalComponent } from './modals/appeal-petition-modal/appeal-petition-modal.component';
import { AppealPetitionSubmissionComponent } from '@app/gateway/user-profile/my-appeals/appealPetitionSubmission/appeal-petition-submission.component';
import { A11yModule } from '@angular/cdk/a11y'
import { IdVerificationSuccessComponent } from './modals/ridp-modals/id-verifcation-success/id-verification-success.component';
import { IdVerificationServiceDownComponent } from './modals/ridp-modals/id-verifcation-serviceDown/id-verification-serviceDown.component';
import { IdVerificationPendingComponent } from './modals/ridp-modals/id-verification-pending/id-verification-pending.component';
import { IdVerifyUnsuccessComponent } from './modals/ridp-modals/id-verify-unsuccess/id-verify-unsuccess.component';
import { IdVerifyErrorComponent } from './modals/ridp-modals/id-verify-error/id-verify-error.component';
import { VerifyIdentityComponent } from './modals/ridp-modals/verify-identity/verify-identity.component';
import { ApuRoutingModalComponent } from './modals/apu-routing-modal/apu-routing-modal.component';
import { OtherResourcesTypesModalComponent } from './modals/other-resource-types/other-resources.component';
import { MedicalBillsModalComponent } from './modals/medical-bills/medical-bills.component';
import { MedicalAppealIneligibleComponent } from './modals/medical-appeal-ineligible/medical-appeal-ineligible.component';
import { ConfirmPhoneNumberModalComponent } from './modals/confirm-phonenumber/confirm-phonenumber.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        BsDatepickerModule,
        ModalModule,
        MatSidenavModule,
        PopoverModule,
        AlertModule,
        ProgressbarModule,
        ButtonsModule,
        NgxDatatableModule,
        DirectivesModule,
        PipesModule,
        TranslateModule,
        FileUploadModule,
        MatFormFieldModule,
        MatIconModule,
        MatSelectModule,
        BrowserAnimationsModule,
        MatButtonModule,
        MatSortModule,
        JoyrideModule.forChild(),
        MatExpansionModule,
        A11yModule
    ],
    declarations: [
        HeaderComponent,
        FooterComponent,
        KatieBeckettModalComponent,
        FeedbackComponent,
        IdBarComponent,
        PageTitleComponent,
        ReportAbuseModalComponent,
        SaveExitModalComponent,
        FeedbackSurveyModalComponent,
        CommentsModalComponent,
        ConfirmModalComponent,
        ConfirmAppealModalComponent,
        ConfirmAppealRespComponent,
        ConfirmFileAppealAuthAckComponent,
        PeopleDeleteModalComponent,
        IncomeDeductionModalComponent,
        ButtonBarComponent,
        ContactPhonesComponent,
        CountComponent,
        ErrorMessagesComponent,
        FieldComponent,
        FormComponent,
        InputGroupComponent,
        ContactInfoComponent,
        NameAddressComponent,
        NotFoundComponent,
        PopoverComponent,
        SearchComponent,
        SpinnerComponent,
        SmartAppBannerComponent,
        StepperComponent,
        TableComponent,
        TabsetComponent,
        TopLevelComponent,
        DatepickerComponent,
        CheckboxDropdownListComponent,
        CheckboxListComponent,
        CheckboxComponent,
        NotificationsComponent,
        CityStateComponent,
        BlockTitleComponent,
        TimeoutModalComponent,
        AnalyticsModalComponent,
        QuestionnaireModalComponent,
        InfoMessagesModalComponent,
        SectionInfoComponent,
        AlertComponent,
        PrimaryCaregiversModalComponent,
        AssistingPersonTypesModalComponent,
        LiquidTypesModalComponent,
        BurialResourcesModalComponent,
        AddressValidationComponent,
        HealthPlansComponent,
        TypesOfProofsComponent,
        FileUploadComponent,
        MobileFileUploadComponent,
        ReviewSummaryTableComponent,
        ChatbotComponent,
        EndCoverageSummaryModalComponent,
        CoverageTutorialModalComponent,
        ReportChangeModalComponent,
        RecordDeleteModalComponent,
        RemoveSvgComponent,
        TranslateModalComponent,
        CoOwnerTableComponent,
        AddSvgComponent,
        ExitSvgComponent,
        BrowserIncompatibleModalComponent,
        HealthPlanConfirmModalComponent,
        AppealEligibilityModalComponent,
        DuplicateContinuanceAppealModalComponent,
        DuplicateWithdrawlAppealModalComponent,
        NudgeComponent,
        DuplicateTaxDepOrJointFilerComponent,
        mobileFAQComponent,
        ConfirmHohComponent,
        ConfirmSsnModalComponent,
        ConfirmOpenAppealModalComponent,
        HealthPlanCancelModalComponent,
        HealthPlanCancelConfirmComponent,
        ScrollTopComponent,
        HealthPlanCancelErrorComponent,
        SubmissionTypesComponent,
        DocumentTypesComponent,
        DocUploadFaqsComponent,
        DocUploadLimitComponent,
        AppealFactModalComponent,
        AppealFactSubmissionComponent,
        MemberLoginHelpGlossaryComponent,
        LargeDataComponent,
        AppealPetitionModalComponent,
        AppealPetitionSubmissionComponent,
        IdVerificationSuccessComponent,
        IdVerificationServiceDownComponent,
        IdVerificationPendingComponent,
        IdVerifyUnsuccessComponent,
        IdVerifyErrorComponent,
        VerifyIdentityComponent,
        ApuRoutingModalComponent,
        OtherResourcesTypesModalComponent,
        MedicalBillsModalComponent,
        MedicalAppealIneligibleComponent,
        ImmigrationTypesModalComponent,
        ConfirmPhoneNumberModalComponent,
    ],
    exports: [
        // Modules
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        BsDatepickerModule,
        ModalModule,
        MatSidenavModule,
        PopoverModule,
        AlertModule,
        ProgressbarModule,
        ButtonsModule,
        NgxDatatableModule,
        DirectivesModule,
        PipesModule,
        // Components
        HeaderComponent,
        FooterComponent,
        FeedbackComponent,
        IdBarComponent,
        PageTitleComponent,
        ReportAbuseModalComponent,
        SaveExitModalComponent,
        FeedbackSurveyModalComponent,
        CommentsModalComponent,
        ConfirmModalComponent,
        ConfirmAppealModalComponent,
        PeopleDeleteModalComponent,
        ButtonBarComponent,
        ContactPhonesComponent,
        CountComponent,
        ErrorMessagesComponent,
        KatieBeckettModalComponent,
        FieldComponent,
        FormComponent,
        InputGroupComponent,
        ContactInfoComponent,
        NameAddressComponent,
        NotFoundComponent,
        PopoverComponent,
        SearchComponent,
        SpinnerComponent,
        SmartAppBannerComponent,
        StepperComponent,
        TableComponent,
        TabsetComponent,
        TopLevelComponent,
        DatepickerComponent,
        CheckboxDropdownListComponent,
        CheckboxListComponent,
        CheckboxComponent,
        NotificationsComponent,
        CityStateComponent,
        BlockTitleComponent,
        TimeoutModalComponent,
        AnalyticsModalComponent,
        QuestionnaireModalComponent,
        InfoMessagesModalComponent,
        SectionInfoComponent,
        AlertComponent,
        AddressValidationComponent,
        HealthPlansComponent,
        FileUploadComponent,
        MobileFileUploadComponent,
        ReviewSummaryTableComponent,
        ChatbotComponent,
        RecordDeleteModalComponent,
        RemoveSvgComponent,
        IncomeDeductionModalComponent,
        CoOwnerTableComponent,
        AddSvgComponent,
        ExitSvgComponent,
        HealthPlanConfirmModalComponent,
        AppealEligibilityModalComponent,
        DuplicateContinuanceAppealModalComponent,
        DuplicateWithdrawlAppealModalComponent,
        NudgeComponent,
        DuplicateTaxDepOrJointFilerComponent,
        mobileFAQComponent,
        ConfirmSsnModalComponent,
        ConfirmOpenAppealModalComponent,
        ScrollTopComponent,
        HealthPlanCancelConfirmComponent,
        MemberLoginHelpGlossaryComponent,
        LargeDataComponent,
        A11yModule,
        IdVerificationSuccessComponent,
        IdVerificationServiceDownComponent,
        IdVerificationPendingComponent,
        IdVerifyUnsuccessComponent,
        IdVerifyErrorComponent,
        VerifyIdentityComponent,
        ConfirmPhoneNumberModalComponent,
    ],
    providers: [BsDatepickerConfig, ProgressbarConfig]
})
export class ComponentsModule { }